let apiUrl;
let webUrl;
let environment;
let cuUrl = 'https://www.claveunica.gob.cl';

const hostname = window && window.location && window.location.hostname;

if(hostname === 'pagos.cristourviajes.cl') {
    apiUrl = 'https://cristourviajes.cl/estugiraapiv2';
    webUrl = 'https://pagos.cristourviajes.cl';
    environment = 'PRODUCTION';
}else if(hostname === 'testpagos.cristourviajes.cl') {
    apiUrl = 'https://cristourviajes.cl/estugiraapiv2';
    webUrl = 'https://testpagos.cristourviajes.cl';
    environment = 'TEST';
}
else {
    apiUrl = 'http://cristourviajes-local.lazos.cl:3001';
    webUrl = 'http://cristourviajes-local.lazos.cl:3000';
    environment = 'DEVELOPMENT';
}




export const APP_CONFIG = { apiUrl, webUrl, environment, cuUrl };
